
export enum EDynamicColumnType {
  STRING = "TYPE_STRING",
  NUMBER = "TYPE_NUMBER",
  DATE = "TYPE_DATE",
  SELECT = "TYPE_SELECT",
};

export interface ISelectOption<T = string> {
  label: string;
  value: T;
  disabled?: boolean;
};
// TODO: Comentar


export interface IDynamicColumnFilter {
  type: EDynamicColumnType;
  grid: number;
  field: string;
  label: string;
  values?: ISelectOption[];
};